var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "1240",
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "서비스 문의",
      "showsFilterButton": ""
    },
    model: {
      value: _vm.showsSearch,
      callback: function ($$v) {
        _vm.showsSearch = $$v;
      },
      expression: "showsSearch"
    }
  }), _c('service-inquiry-list-search', _vm._b({}, 'service-inquiry-list-search', {
    showsSearch: _vm.showsSearch
  }, false)), _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "items-per-page": -1,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "show-expand": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.inquirer`,
      fn: function (_ref2) {
        var _item$meta, _item$meta2;
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s((item === null || item === void 0 ? void 0 : (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.companyName) || "-"))]), _vm._v(" "), _c('br'), _c('span', [_vm._v(_vm._s((item === null || item === void 0 ? void 0 : (_item$meta2 = item.meta) === null || _item$meta2 === void 0 ? void 0 : _item$meta2.name) || "-"))])];
      }
    }, {
      key: `item.state`,
      fn: function (_ref3) {
        var _vm$FORM_STATES__SERV;
        var item = _ref3.item,
          value = _ref3.value;
        return [_c('service-inquiry-state-edit', _vm._g({
          attrs: {
            "value": item
          }
        }, {
          update: _vm.update
        }), [_c('v-card', {
          staticClass: "px-4 py-2 my-n2",
          attrs: {
            "flat": "",
            "tile": ""
          }
        }, [_vm._v(_vm._s((_vm$FORM_STATES__SERV = _vm.FORM_STATES__SERVICE_INQUIRY[value]) === null || _vm$FORM_STATES__SERV === void 0 ? void 0 : _vm$FORM_STATES__SERV.text))])], 1)];
      }
    }, {
      key: `item.memo`,
      fn: function (_ref4) {
        var item = _ref4.item,
          value = _ref4.value;
        return [_c('form-memo-edit', _vm._g({
          attrs: {
            "value": item
          }
        }, {
          update: _vm.update
        }), [_c('v-card', {
          staticClass: "px-4 py-2 my-n2 fill-height",
          attrs: {
            "flat": "",
            "tile": "",
            "color": "transparent"
          }
        }, [_vm._v(" " + _vm._s(value || "-") + " ")])], 1)];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref5) {
        var item = _ref5.item,
          headers = _ref5.headers;
        return [_c('td'), _c('td', {
          staticClass: "px-0",
          attrs: {
            "colspan": headers.length - 1
          }
        }, [_c('v-sheet', {
          staticClass: "fill-height"
        }, [_c('v-card-subtitle', {
          staticClass: "caption"
        }, [_vm._v("문의내용")]), _c('v-card-text', {
          staticClass: "white-space-pre-line"
        }, [_vm._v(" " + _vm._s(item.content) + " ")])], 1)], 1)];
      }
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers,
    loading: _vm.loading
  }, false)), _c('v-pagination', {
    staticClass: "my-2",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }